export const CandidateReputationDetailsSort = {
  ResponseDate: 'ResponseDate',
  TalentName: 'TalentName',
  AccountName: 'AccountName',
  TopTenPercent: 'TopTenPercent',
  Status: 'Status',
  MeetsExpectations: 'MeetsExpectations',
  RespondentName: 'RespondentName',
  EngagementName: 'EngagementName',
  AccountOwner: 'AccountOwner',
  MatterId: 'MatterId',
} as const;

export const CandidateReputationActions = {
  SHARED: 'Shared',
  SHARED_LIVE: 'SharedLive',
  DISPUTED: 'Disputed',
  DISMISSED: 'Dismissed',
} as const;
